export default __webpack_public_path__ + "static/media/upload.2e348a05.png";